export const CLIENT_SELECT_KEY = 'selectedClient';
export const CLIENT_PERMISSIONS_KEY = 'clientPermissions';